import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import ListComponent from "./ListComponent";

import { useSearchParams, useNavigate } from "react-router-dom";
import CreateComponent from "./CreateComponent";

const MainComponent = (props) => {
  const { isError } = props;

  var [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const [generalFormData, setGeneralFormData] = useState(props.InitialFormData);
  const [generalDuplicateFormData, setGeneralDuplicateFormData] = useState(
    props.InitialFormDuplicateDataStore
  );

  const [createOrUpdate, setCreateOrUpdate] = useState("Create");
  const [toggleDropShadow, setToggleDropShadow] = useState(
    searchParams.get("isFromOther")
      ? searchParams.get("isFromOther") === "true"
      : false
  ); //data in state is set from query parameter of other module
  const [optionName, setOptionName] = useState(props.OptionName);

  const [isFromOther, setIsFromOther] = useState(
    searchParams.get("isFromOther") === "true"
  );

  useEffect(() => {
    //to add input data after edit button click
    setGeneralFormData({ ...props.EditData });
  }, [props.EditData]);

  useEffect(() => {
    //to initialize form input data after submit

    setGeneralFormData({ ...props.InitialFormDataStore });
  }, [props.InitialFormDataStore]);

  useEffect(() => {
    //to make popups overlay open or close based on error
    if (isError) {
      setToggleDropShadow(true);
    } else {
      setToggleDropShadow(false);
    }
  }, [isError]);
  useEffect(() => {
    if (props.isSuccess) {
      setToggleDropShadow(false);
    }
  }, [props.isSuccess]);

  useEffect(() => {
    setGeneralDuplicateFormData(props.InitialFormDuplicateDataStore);
  }, [props.InitialFormDuplicateDataStore]);

  // function to toggle drop shadow
  const onChangeDropShadowHandler = (createBtnData) => {
    // to change create or update button text

    setOptionName(` ${createBtnData} ${props.OptionNameList}`);
    setCreateOrUpdate(createBtnData);
    setToggleDropShadow((prevState) => !prevState);
    setIsFromOther(false);
    isFromOther && navigate(-1);
  };
  const dispatch = useDispatch();

  // function to change input change handler
  const onInputChangeHandler = (name, value) => {
    console.log(name, value);
    const formData = JSON.parse(JSON.stringify(generalFormData)); //deep copy

    formData[name] = value;
    setGeneralFormData(formData);
  };
  //function to change duplicate input change handler
  const onDuplicateInputChangeHandler = (name, value, index) => {
    const formData = JSON.parse(JSON.stringify(generalDuplicateFormData));

    formData[name][index] = value;

    setGeneralDuplicateFormData(formData);
  };

  // function to submit form data
  const setListHandler = async (e) => {
    e.preventDefault();

    // let generalDuplicateFormDatas =
    //   generalDuplicateFormData?.quality?.length > 0
    //     ? JSON.parse(JSON.stringify(generalDuplicateFormData))
    //     : null;

    // await dispatch(
    //   props.createFun(
    //     JSON.parse(JSON.stringify(generalFormData)),
    //     generalDuplicateFormData,
    //     props.createOrAddMore
    //   )
    // );

    isFromOther && navigate(-1);
  };

  //function to submit edit form data
  const onEditSubmit = (e) => {
    e.preventDefault();
    // dispatch(props.updateFun(generalFormData));
    if (!isError) {
      setGeneralFormData(props.InitialFormData);
      setToggleDropShadow(false);
    }
    isFromOther && navigate(-1);
  };
  //function to handle edited data from form
  const onEditHandler = async (data) => {
    setIsFromOther(false);
    setOptionName(`Update ${props.OptionNameList}`);
    // dispatch(
    //   props.getDataForEdit(
    //     typeof data === "number" ? data : data.id,
    //     props.generalModuleList
    //   )
    // );
  };
  //function to cancel form inputed data
  const onCancelHandler = (e) => {
    // dispatch(props.setErrorData({ message: {}, isError: false }));
    setGeneralFormData(props.InitialFormData);
    setIsFromOther(false);
  };
  const onDeleteHandler = (data) => {
    // dispatch(props.delteFun(data.id));
  };
  const onSubmitAdjustData = (e) => {
    e.preventDefault();
    // dispatch(
    //   props.createAdjust(
    //     JSON.parse(JSON.stringify(generalFormData)),
    //     props.InitialAdjustData,
    //     generalDuplicateFormData
    //   )
    // );
  };
  const onDeleteMultiFieldHandler = (index) => {
    const tempFormData = JSON.parse(JSON.stringify(generalDuplicateFormData));
    Object.keys(tempFormData).forEach((item) => {
      tempFormData[item].splice(index, 1);
    });
    setGeneralDuplicateFormData(tempFormData);
  };
  const onEscPress = () => {
    setToggleDropShadow(false);
  };
  return (
    <>
      {!props.isFromAnotherModule && (
        <CreateComponent
          onSubmitAdjustData={onSubmitAdjustData}
          onDuplicateInputChangeHandler={onDuplicateInputChangeHandler}
          setListHandler={setListHandler}
          onInputChangeHandler={onInputChangeHandler}
          inputFormData={generalFormData}
          generalDuplicateFormData={generalDuplicateFormData}
          // OptionName={"Create Factory"}
          OptionName={optionName}
          OptionNameList={props.OptionNameList}
          toggleDropShadow={toggleDropShadow}
          onChangeDropShadowHandler={onChangeDropShadowHandler}
          createOrUpdate={createOrUpdate}
          onEditSubmit={onEditSubmit}
          onCancelHandler={onCancelHandler}
          FormOptions={props.FormOptions}
          extraAddBtn={props.extraAddBtn}
          extraButtonText={props.extraButtonText}
          isFromOther={isFromOther}
          ErrorData={props.ErrorData}
          FormStyle={props.FormStyle}
          needAdjust={props.needAdjust} //it is used if there is no edit but need adjust
          NewFormOptions={props.NewFormOptions} //for only if need to create duplicate form
          adjustedFormStock={props.adjustedFormStock} //it is used if there is no edit but need adjust
          inputAdjustHandler={props.inputAdjustHandler} //it is used if there is no edit but need adjust
          InitialAdjustData={props.InitialAdjustData} //it is used if there is no edit but need adjust
          listForLength={props.listForLength}
          showOtherFormBtn={props.showOtherFormBtn} //it is used if there is no edit but need adjust
          notShowEditBtn={props.notShowEditBtn}
          onDeleteMultiFieldHandler={onDeleteMultiFieldHandler}
          onEscPress={onEscPress}
        />
      )}
      <ListComponent
        setProducType={props.setProducType}
        onEditHandler={onEditHandler}
        onChangeDropShadowHandler={onChangeDropShadowHandler}
        onCancelHandler={onCancelHandler}
        // OptionName={"Factory"}
        OptionName={props.OptionNameList}
        generalList={props.generalList}
        headTitle={props.headTitle}
        onDeleteHandler={onDeleteHandler}
        isNotDeleteBtn={props.isNotDeleteBtn}
        OptionNameList={props.OptionNameList}
        secondCreateBtn={props.secondCreateBtn}
        needAdjust={props.needAdjust} //it is used if there is no edit but need adjust
        setDataForAdjust={props.setDataForAdjust}
        notShowEditBtn={props.notShowEditBtn}
      />
    </>
  );
};
export default MainComponent;
